define('view/disclosure/modals/decision.confirmation.modal',['require','exports','module','underscore','uikit/uikit','blockit','backbone.radio','fukit','fukit'],function(require, exports, module) {
  //prettier-ignore
  var _       = require('underscore'),
      UIKit   = require('uikit/uikit'),
      BlocKit = require('blockit'),
      Radio   = require('backbone.radio'),
      Factory = require('fukit').Factory,

      //Behaviors
      EnableOnlyOnUnsavedChangesBehavior = require('fukit').EnableOnlyOnUnsavedChangesBehavior;

  var ReviewerAssignmentModal = UIKit.Modal2.extend({
    className: 'ui modal confirmation',

    options: _.extend({}, UIKit.Modal2.prototype.options, { closable: true }),

    header: {
      type: UIKit.Modal2.HeaderView,
      text: 'Disclosure Resolution',
    },

    content: function() {
      return {
        components: [
          {
            type: BlocKit.FormContainerView,
            basic: true,
            components: [
              {
                name: 'decisionCheckboxGroup',
                label: {
                  text: 'Resolution',
                },
                content: {
                  type: UIKit.CheckboxGroup,
                  radio: true,
                  collection: this.getOption('outcomeCollection'),
                  model: this.getOption('decisionModel'),
                  bindings: {
                    value: 'outcome',
                  },
                  childBindings: {
                    text: 'displayName',
                  },
                  value: null,
                },
              },
            ],
          },
        ],
      };
    },

    actions: function() {
      return {
        components: [
          {
            type: UIKit.Modal2.DenyButtonView,
            text: 'Cancel',
          },
          {
            type: UIKit.Modal2.ConfirmButtonView,
            text: 'Resolve',
            icon: 'save',
            disabled: false,
            model: this.getOption('model'),
            behaviors: {
              EnableOnlyOnUnsavedChangesBehavior: {
                behaviorClass: EnableOnlyOnUnsavedChangesBehavior,
              },
              InvokeMethodOnEventBehavior: {
                events: {
                  press: {
                    method: function() {
                      this.view.model
                        .save()
                        .promise()
                        .then(function() {
                          Radio.channel('resolveButton').trigger('resolve:disclosure');
                        })
                        .catch(function(error) {
                          console.error('An error occurred while saving InvokeMethodOnEventBehavior:', error);
                        });
                    },
                  },
                },
                behaviorClass: BlocKit.InvokeMethodOnEventBehavior,
              },
            },
          },
        ],
      };
    },
  });

  module.exports = ReviewerAssignmentModal;
});

